import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Radio, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components'
import { useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';




export const AbdmForm = () => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const methods = useForm();
    const { handleSubmit, setValue, reset } = methods;


    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto',
                maxWidth: '100vw',
                minHeight: '100vh'
            }}>
                <Container
                    sx={{
                        mt: 2,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',

                    }}
                >
                    <FormProvider methods={methods} >
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 3,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                ABDM
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        reset();
                                    }}
                                    id={`${lastPathSegment}Write`}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Stack spacing={2} sx={{ marginBottom: "1%" }}>
                            <Stack direction="row" spacing={1} width="70%">
                                <Radio
                                    name="mobile"
                                    sx={{ flex: 0.8 }}
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />
                                <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700 }}>Mobile No.</Typography>
                                <Radio
                                    name="aadhar_no"
                                    sx={{ flex: 0.8 }}
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />
                                <Typography sx={{ flex: 0.3, fontSize: '1.6rem', fontWeight: 700 }}>Aadhar No.</Typography>
                            </Stack>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.1, fontSize: '1.6rem', fontWeight: 700 }}>ABDM Data</Typography>
                                <TextField
                                    name="city"
                                    sx={{ flex: 0.6, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                    inputProps={{ sx: { fontSize: '1.4rem' } }}
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />
                                <Button
                                    disabled={!['new'].includes(currentAction)}
                                    sx={{ width: 10, p: 0.8, height: '100%' }}
                                    variant="contained"
                                >
                                    <SearchIcon />
                                </Button>
                            </Stack>
                        </Stack>
                    </FormProvider>
                </Container>
            </Paper>

        </>
    );
};
